import { GetProductListResponse } from "services/interface";
import styled from "@emotion/styled";
import { Row } from "antd";
import NotFoundData from "components/NotFoundData";
import React, { FC, useEffect } from "react";
import ProductCard from "../ProductCard";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";

interface ProductOnSaleProps {
  isLoading: boolean;
  data: GetProductListResponse | undefined;
  refetch: () => void;
  refetchTo: () => void;
  
}

const ProductOnSale: FC<ProductOnSaleProps> = ({
  isLoading,
  data,
  refetch,
  refetchTo,
}) => {

  const dispatch = useAppDispatch();


  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [isLoading]);


  //ยังไม่มีสินค้าในตอนนี้
  if (!data || data.products?.length === 0) {
    return <NotFoundData text="ยังไม่มีสินค้าในตอนนี้" />;
  }

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >

      { data && data?.products?.map((item) => {
        return (
          <ProductCard
            key={item.id}
            data={item}
            refetch={refetch}
            refetchTo={refetchTo}
          />
        );
      })}

       
   
      </Row>
    </WrapperAll>
  );
};

export default ProductOnSale;

const WrapperAll = styled.div`
  padding: 16px 0px 10px 0px;
  background-color: #efefef;
`;
